import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { startOfDay, addMinutes } from "date-fns";
import DateTimeField from "../../../Form/DateTimeField";
import {
  MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_SCHEDULE_BUTTON,
  BUTTON_PUBLISH_NOW,
  SCHEDULE_DATE_MIN_FUTURE_ERROR,
} from "../../../../i18n/keysTranslations";

const ScheduleDateSection = () => {
  const { t } = useTranslation();
  const {
    control,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();

  const validationRules = {
    validate: (value) => {
      if (!value) {
        return true;
      }

      const now = new Date();
      const minFutureDate = addMinutes(now, 5);
      if (value < minFutureDate) {
        return t(SCHEDULE_DATE_MIN_FUTURE_ERROR);
      }

      return true;
    },
  };

  const onDateChange = (date) => {
    setValue("scheduledDate", date, { shouldValidate: true });
    trigger("scheduledDate");
  };

  return (
    <DateTimeField
      name="scheduledDate"
      control={control}
      label={t(MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_SCHEDULE_BUTTON)}
      minDate={startOfDay(new Date())}
      fullWidth={true}
      variant="filled"
      clearable={true}
      errors={errors}
      rules={validationRules}
      actionsChange={onDateChange}
      showStartNowButton={true}
      startNowSetsNull={true}
      nowCustomPlaceholder={BUTTON_PUBLISH_NOW}
    />
  );
};

export default ScheduleDateSection;
